import React, { useState } from 'react';
import { useContent } from '../context/ContentContext';
import './JournalSection.css';

const JournalSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const { content } = useContent();
  const journalEntries = content.journal;

  const slidesToShow = window.innerWidth > 1024 ? 3 : window.innerWidth > 768 ? 2 : 1;

  const handleNext = () => {
    if (currentSlide < journalEntries.length - slidesToShow) {
      setCurrentSlide(currentSlide + 1);
    }
  };

  const handlePrev = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };

  return (
    <section className="journal-section" id="journal">
      <div className="journal-container">
        <div className="journal-header fade-in-up">
          <h2 className="journal-title">Journal</h2>
          <p className="journal-description">
            Discover more about old and new personal projects. Access unreleased
            behind-the-scenes material. Read the stories behind the photographs
            and join the conversation.
          </p>
          <a href="/journal" className="journal-link smooth-hover">
            More projects here →
          </a>
        </div>
        <div className="journal-carousel">
          <div
            className="journal-slider"
            style={{
              transform: `translateX(-${currentSlide * (100 / slidesToShow)}%)`,
            }}
          >
            {journalEntries.map((entry) => (
              <div key={entry.id} className="journal-slide smooth-hover scale-in">
                <div className="journal-image image-reveal">
                  <img src={entry.image} alt={entry.title} />
                </div>
                <div className="journal-content">
                  <h3>{entry.title}</h3>
                  <p className="journal-date">{entry.date}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="journal-controls">
            <button
              className="journal-btn journal-prev"
              onClick={handlePrev}
              disabled={currentSlide === 0}
              aria-label="Previous"
            >
              ←
            </button>
            <button
              className="journal-btn journal-next"
              onClick={handleNext}
              disabled={currentSlide >= journalEntries.length - slidesToShow}
              aria-label="Next"
            >
              →
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JournalSection;

